import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { HeaderComponent } from "./shared/components/header/header.component";
import { SidebarComponent } from "./shared/components/sidebar/sidebar.component";
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, SidebarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'AOC-multisig-admin';

  router=inject(Router)
  showHeader=false;
  showSideBar=false
  isRestricted = false;
  private routerSubscription!: Subscription;

  ngOnInit(): void {
    initFlowbite();

    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const restrictedRoute = '/'; // Only disable navigation on this route

      this.isRestricted = event.urlAfterRedirects === restrictedRoute;
      // Show/hide header and sidebar accordingly
      this.showHeader = !this.isRestricted;
      this.showSideBar = !this.isRestricted;
    });
  }

  ngOnDestroy(){
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
